module.exports = __webpack_public_path__ + "img/editar.d4d7a55a.svg";